import { render, staticRenderFns } from "./PowerOfAttorneyOneSignatory.vue?vue&type=template&id=049b0b2d&scoped=true&"
import script from "./PowerOfAttorneyOneSignatory.vue?vue&type=script&lang=js&"
export * from "./PowerOfAttorneyOneSignatory.vue?vue&type=script&lang=js&"
import style0 from "./PowerOfAttorneyOneSignatory.vue?vue&type=style&index=0&id=049b0b2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049b0b2d",
  null
  
)

export default component.exports